import type { StateTree } from '@makemydeal/dr-dash-types';
import DealSummaryItem from '../common/DealSummaryItem';

import * as constants from '../../constants';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import { LEASE } from '@makemydeal/dr-platform-types';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const AdjustedSellingPrice = () => {
    const salePrice = useTrackedSelector((state: StateTree) => offerReduxSelectors.getVehicleSalePrice(state, LEASE), {
        component: 'AdjustedSellingPrice',
        field: 'vehicleSalePrice'
    });
    const vehicleSalePrice = formatDollarsAndCents(salePrice);
    const { showDetailedView } = useDealSummary();
    return (
        <DealSummaryItem
            label={constants.ADJUSTED_SELLING_PRICE}
            value={vehicleSalePrice}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default AdjustedSellingPrice;
